import React from "react";
import { Globe } from "lucide-react";

/** External traffic sources list with clickable URLs. */
const TopReferrersList = ({ items, lang }) => {
  if (!items || items.length === 0) {
    return (
      <div className="py-8 text-center">
        <Globe className="w-6 h-6 text-[#C5A059] mx-auto mb-2 opacity-50" strokeWidth={1.25} />
        <p className="text-xs text-[#A19E9C]">
          {lang === "fr"
            ? "Pas encore de référents externes"
            : "No external referrers yet"}
        </p>
      </div>
    );
  }
  return (
    <ul className="space-y-2 max-h-[220px] overflow-y-auto pr-1">
      {items.map((r) => (
        <li
          key={r.referrer}
          className="flex items-center justify-between text-xs"
        >
          <a
            href={r.referrer}
            target="_blank"
            rel="noreferrer"
            className="text-[#F2EBE5] hover:text-[#C5A059] truncate max-w-[75%]"
          >
            {r.referrer}
          </a>
          <span className="text-[#C5A059]">{r.count}</span>
        </li>
      ))}
    </ul>
  );
};

export default TopReferrersList;
